import axios from "axios";
import { baseUrl } from "../utils/constants";

// Get All Expense Claims //
export const getExpenseClaimApi = async (userToken, params)=>{
    return new Promise(async (resolve, reject)=>{
        const url = `${baseUrl}/contractor/get-expense-claims?page=${params?.page}&limit=${params.limit}${params?.date ? (`&date=${params.date}`) : ''}${!params?.status || params?.status === "ALL" ? '': (`&status=${params.status}`)}${params.site_id ? (`&site_id=${params.site_id}`) : ''}`
        try{
            // const token = localStorage.getItem("userToken");
            // let userToken = userToken.replace(/['"]+/g, "")
            let response = await axios.get(url, {
                headers: {
                    Authorization: userToken,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            })
            resolve(response.data)
        }catch (error) {
            console.log("api error::", error.response?.data);
            reject(error.response?.data)
        }
    })
}

// Download Expense Claim //
export const downloadExpenseClaimApi = async (userToken, params)=>{
    return new Promise(async (resolve, reject)=>{
        const url = `${baseUrl}/contractor/download-expense-claim/${params}`
        try{
            let response = await axios.get(url, {
                headers: {
                    Authorization: userToken,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                responseType: 'blob'
            })
            resolve(response.data)
        }catch (error) {
            console.log("api error::", error.response?.data);
            reject(error.response?.data)
        }
    })
}

export const changeExpenseStatusApi = async (userToken, params)=>{
    return new Promise(async (resolve, reject) => {
        try {
          let response = await axios({
            method: "POST",
            headers: {
              Authorization: userToken,
              "Content-Type": "application/x-www-form-urlencoded",
            },
            url: `${baseUrl}/contractor/change-expense-claim-status`,
            data: params,
          });
          resolve(response.data);
        } catch (error) {
          console.log("error::", error.response.data);
          reject(error.response.data);
        }
      });
}